import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  projectId: "affiliate-ninja-app-2026",
  appId: "1:588835322935:web:f18308dc9504962194d3b2",
  storageBucket: "affiliate-ninja-app-2026.firebasestorage.app",
  apiKey: "AIzaSyCRkZRKMjX7t01bUsyxTgVVm1x6TARun5A",
  authDomain: "affiliate-ninja-app-2026.firebaseapp.com",
  messagingSenderId: "588835322935",
};

let app;
let auth;
let db;

try {
  console.log("[FIREBASE] Initializing...");
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  console.log("[FIREBASE] Success");
} catch (error) {
  console.error("[FIREBASE CRITICAL ERROR]", error);
}

export { app, auth, db };
